<template>
  <div class="page-container">
    <div class="page-main">
      <el-card class="page-body" v-loading="isLoading">
        <div slot="header">
          <el-form :inline="true" :model="reqParams" size="mini" label-width="120px" class="search-params-form">
            <el-form-item label="公司名称：">
              <el-input placeholder="请输入公司名称" v-model="reqParams.companyName" size="mini" clearable></el-input>
            </el-form-item>
            <el-form-item label="员工姓名：">
              <el-input placeholder="请输入员工姓名" v-model="reqParams.staffName" size="mini" clearable></el-input>
            </el-form-item>
            <el-form-item label="角色名称：">
              <el-input placeholder="请输入角色名称" v-model="reqParams.roleName" size="mini" clearable></el-input>
            </el-form-item>
            <el-form-item label="联系方式：">
              <el-input placeholder="请输入联系方式" v-model="reqParams.userPhone" size="mini" clearable></el-input>
            </el-form-item>
            <el-form-item label=" ">
              <div class="search-button">
                <el-button type="primary" @click="onSearch">查询</el-button>
              </div>
              <el-button @click="onResetReqParams">重置</el-button>
            </el-form-item>
          </el-form>
        </div> <!-- end of header -->
        <div class="role-card-body">
          <div class="table-container">
            <el-table :data="staffInfoList"
                      border
                      style="width: 100%"
                      stripe
                      size="mini"
                      v-loading="isLoading">
              <el-table-column
                label="公司名称"
                min-width="100"
                align="center"
                property="userCompanyName">
              </el-table-column>
              <el-table-column
                label="员工姓名"
                min-width="60"
                align="center"
                property="userName">
              </el-table-column>
              <el-table-column
                label="角色"
                align="center"
                property="roleText"
                min-width="300">
              </el-table-column>
              <el-table-column
                label="联系方式"
                align="center"
                property="userPhone"
                min-width="100">
              </el-table-column>
              <el-table-column
                label="操作"
                align="center"
                min-width="160">
                <template slot-scope="scope">
                  <!-- <el-button @click="onReadStaff(scope.row)" type="primary" plain size="mini">查看</el-button> -->
                  <el-button style="padding:0.46667rem 0.5rem;" @click="onAuthorizeCollectorRole(scope.row)" type="success" plain size="mini">授权采集员</el-button>
                  <el-button style="padding:0.46667rem 0.5rem;" @click="onAuthorizeAgronomistRole(scope.row)" type="success" plain size="mini">授权经销商</el-button>
                  <el-button style="padding:0.46667rem 0.5rem;" @click="onEditStaff(scope.row)" type="success" plain size="mini">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="footer">
          <el-pagination
            background
            small
            @current-change="onChangePager"
            :current-page="reqParams.page"
            :page-size="reqParams.perPage"
            layout="total, prev, pager, next"
            :total="total">
          </el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getRequest } from 'utils/http-service'
import { URL_STAFF_ROLE_LIST } from '../../constants/url'
export default {
  name: 'staffRoleList',

  data () {
    return {
      reqParams: {
        companyName: '',
        staffName: '',
        roleName: '',
        userPhone: '',
        accountState: '',
        page: 1,
        perPage: 10
      },
      staffInfoList: [],
      isLoading: false,
      total: 0
    }
  },

  methods: {
    getStaffInfoList () {
      this.isLoading = true
      let reqParams = this.reqParams
      let params = {
        searchCompanyName: reqParams.companyName,
        searchStaffName: reqParams.staffName,
        searchRoleName: reqParams.roleName,
        searchUserPhone: reqParams.userPhone,
        pageNumber: reqParams.page,
        pageSize: reqParams.perPage
      }

      getRequest(URL_STAFF_ROLE_LIST, params)
        .then(res => {
          if (res.code !== 0) {
            this.isLoading = false
            console.error(this.$route.name + 'getStaffInfoList() res', res)
            this.$message({ message: res.message || '服务器异常，请稍后重试！', showClose: true, offset: 300, type: 'error' })
            return
          }

          let dataList = []
          try {
            dataList = this._convertDto2Vo(res.data.pageData)
          } catch (error) {
            console.error(this.$route.name + '_convertDto2Vo() err', error)
          }

          if (!Array.isArray(dataList) || dataList.length === 0) {
            this.isLoading = false
            this.$message({
              showClose: true,
              message: '当前没有任何信息！',
              offset: 300,
              type: 'warning'
            })
            console.error(this.$route.name + ' getStaffInfoList() err: 当前没有任何信息！')
            this.staffInfoList = []
            this.total = 0
            return
          }

          this.staffInfoList = dataList
          this.total = res.data.totalRecordCount
          this.isLoading = false
        })
        .catch(err => {
          this.isLoading = false
          console.error(this.$route.name + ' getStaffInfoList() err', err)
          this.$message({ message: err.message || '服务器异常，请稍后重试！', showClose: true, offset: 300, type: 'error' })
        })
    },

    _convertDto2Vo (dataList) {
      let vo = []

      dataList.forEach(companyItem => {
        let roleText = ''

        for (let i = 0; i < companyItem.roleSummaryCns.length; i++) {
          if (companyItem.roleSummaryCns.length > 7 && i === 7) {
            roleText += `等${companyItem.roleSummaryCns.length}个角色`
            break
          }

          if (roleText) {
            roleText += '、'
          }

          roleText += companyItem.roleSummaryCns[i]
        }

        vo.push({
          userCompanyID: companyItem.userCompanyID,
          userCompanyName: companyItem.userCompanyName,
          userID: companyItem.userID,
          userName: companyItem.userName,
          roleText: roleText,
          userPhone: companyItem.userPhone
        })
      })

      return vo
    },

    onSearch () {
      this.reqParams.page = 1
      this.getStaffInfoList()
    },

    onResetReqParams () {
      this.reqParams = {
        companyName: '',
        staffName: '',
        roleName: '',
        page: 1,
        perPage: 10
      }

      this.getStaffInfoList()
    },

    onChangePager (newPage) {
      this.reqParams.page = newPage
      this.getStaffInfoList()
    },

    onReadStaff (staff) {
      this.$router.push({
        name: 'staff-role-configure',
        params: {
          userID: staff.userID,
          action: 'get'
        }
      })
    },

    onEditStaff (staff) {
      this.$router.push({
        name: 'staff-role-configure',
        params: {
          userID: staff.userID,
          action: 'put'
        }
      })
    },

    onAuthorizeCollectorRole (staff) {
      this.$router.push({
        name: 'staff-role-configure-shortcut',
        params: {
          userID: staff.userID,
          action: 'put',
          fastConfigRoleID: 9
        }
      })
    },

    onAuthorizeAgronomistRole (staff) {
      this.$router.push({
        name: 'staff-role-configure-shortcut',
        params: {
          userID: staff.userID,
          action: 'put',
          fastConfigRoleID: 18
        }
      })
    }
  },
  // created () {
  //   this.getStaffInfoList()
  // },
  activated () {
    if (this.$route.params.userName && this.$route.params.userPhone) {
      let userPhones = []
      userPhones = this.$route.params.userPhone.split(',')
      this.reqParams.staffName = this.$route.params.userName
      this.reqParams.userPhone = userPhones[0]
      this.onSearch()
      this.$route.params.userName = ''
      this.$route.params.userPhone = ''
    } else {
      this.getStaffInfoList()
    }
  }
}
</script>

<style lang="less" scoped>
.page-container {
  display: flex;
  flex-direction: column;
  width:100%;
  height:100%;
  padding: 15px 20px;
  .page-main {
    flex: 1;
    width:100%;
    height:100%;
    .page-body {
      display: flex;
      flex-direction: column;
      width:100%;
      height:100%;
      overflow-y: auto;
      /deep/ .el-card__header {
        padding: 14px 20px 4px;
        background-color: #fff;
      }
      /deep/ .el-card__body {
        display: flex;
        flex-direction: column;
        width: 100%;
        flex: 1;
        padding-top: 0;
        padding-bottom: 0;
      }
      .search-params-form {
        width: 100%;
        height: 100%;
        .search-button {
          display: inline-block;
          margin-right: 70px;
        }
      }
      .role-card-body {
        display: flex;
        width: 100%;
        flex: 1;
        .table-container {
          flex: 1;
        }
      }
      .footer {
        display: flex;
        justify-content: flex-end;
        height: 25px;
        margin-top: 15px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/staff-role-assignment/staff-role-list.vue